import PropTypes from 'prop-types';

// Utils
import store from "store";

LineItemOptionList.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.object.isRequired // Assuming value is an object with translations
        })
    ),
    withOptionName: PropTypes.bool
};

function LineItemOptionList({options, withOptionName = false}) {
    if (!options || options.length === 0) {
        return null;
    }

    const organizationDefaultLocale = store.getState().currentOrganization?.retrieved?.defaultLocale;
    const userLocale = store.getState().authentication?.member?.locale;

    if (withOptionName) {
        let optionString

        const validOptions = options.filter((option) =>
            Object.keys(option.option).includes(organizationDefaultLocale) && Object.keys(option.value).includes(organizationDefaultLocale)
        )

        optionString = validOptions
            .map((option) => `${option.option[organizationDefaultLocale]} • ${option.value[organizationDefaultLocale]}`).join(' - ')

        return optionString
    }

    return options
        .map(option => option.value[userLocale] || option.value[organizationDefaultLocale] || option.value[0])
        .join(' · ');
}

export default LineItemOptionList;
